import { render, staticRenderFns } from "./LicenseRequest.vue?vue&type=template&id=aff6f8e0&scoped=true&"
import script from "./LicenseRequest.vue?vue&type=script&lang=js&"
export * from "./LicenseRequest.vue?vue&type=script&lang=js&"
import style0 from "./LicenseRequest.vue?vue&type=style&index=0&id=aff6f8e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff6f8e0",
  null
  
)

export default component.exports